import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../theme/colors';

export const useTimelineDetailsBubbleStyles = makeStyles((theme) => ({
  card: {
    marginTop: '1.4rem',
    backgroundColor: 'white',
    borderRadius: '8px',
    position: 'relative',
    overflow: 'unset',
    width: '65%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    '&::before': {
      position: 'absolute',
      content: "''",
      top: '-1rem',
      left: '1rem',
      width: 0,
      height: 0,
      borderLeft: '6px solid transparent',
      borderRight: '6px solid transparent',
      borderBottom: '1rem solid white'
    }
  },
  title: {
    color: Colors.timelineGray,
    fontSize: '12px',
    textTransform: 'uppercase',
    margin: 0,
    padding: '1rem 1rem 0 1rem'
  },
  content: {
    whiteSpace: 'pre-wrap',
    margin: 0,
    padding: '0 1rem 1rem 1rem'
  },
  disclaimerOuter: {
    margin: 0,
    fontWeight: 500,
    wordWrap: 'break-word',
    padding: '0 1rem 1rem 1rem'
  },
  imageOuter: {
    padding: '8px'
  },
  imageURL: {
    borderRadius: '5px',
    maxWidth: '400px'
  },
  alert: {
    display: 'flex',
    alignItems: 'center'
  },
  link: {
    color: 'inherit',
    fontSize: 'inherit',
    '&:hover': {
      color: 'inherit',
      textDecoration: 'underline !important'
    }
  }
}));
